import { useContext, useMemo } from 'react';
import { RRule } from 'rrule';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { ColorThemeContext } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

export interface Props {
  rule: RRule;
}

export function DescriptiveRecurrenceHeader({ rule }: Props) {
  const colors = useContext(ColorThemeContext);
  const value = useMemo(() => {
    const text = rule
      // @ts-expect-error -- strict migration
      .toText(ruleText => {
        if (ruleText === 'for') {
          return ',';
        }
        if (ruleText === '(~ approximate)') {
          return undefined;
        }
        return ruleText.toString();
      })
      .trim();
    return i18n('card.blocks.recurrenceInput.actionSheet.descriptiveHeader') + text;
  }, [rule]);

  return (
    <>
      <View
        paddingHorizontal={3}
        paddingVertical={1}
        style={{ backgroundColor: colors.backgroundInactive }}
      >
        <Text size="body2" weight="semibold">
          {value}
        </Text>
      </View>
    </>
  );
}
